// ==================================
// 読み込み
// ==================================

// import Splide JS
import Splide from "@splidejs/splide";

export default function initSlider() {
  // ==================================
  // トップページ スライダー
  // ==================================
  function _initHomeSlider() {
    const Sliders = document.querySelectorAll(".js-home-slider");
    if (Sliders.length === 0) return;

    Sliders.forEach((Slider) => {
      // スライド枚数をカウント
      const slideCount = Slider.querySelectorAll(".splide__slide").length;

      // 1枚かどうかを判定
      const isStatic = slideCount <= 1;

      const homeSlider = new Splide(Slider, {
        autoplay: !isStatic,
        arrows: !isStatic,
        pagination: !isStatic,
        rewind: !isStatic,
        drag: !isStatic,
        pauseOnHover: false,
        pauseOnFocus: false,
        type: isStatic ? "slide" : "loop",
        interval: 4000,
        speed: 500,
        focus: "center",
        padding: "20%",
        gap: 32,
        perPage: 1,
        updateOnMove: true,

        // --- レスポンシブ設定 ---
        breakpoints: {
          // 1024px以下 (設定の調整のみ)
          768: {
            padding: "0",
            gap: 16,
            arrows: false,
          },
        },
      });

      homeSlider.mount();
    });
  }

  _initHomeSlider();

  // ==================================
  // 汎用スライダー
  // ==================================

  function _initCommonSlider() {
    const Sliders = document.querySelectorAll(".js-common-slider");
    if (Sliders.length === 0) return;

    Sliders.forEach((Slider) => {
      // スライド枚数をカウント
      const slideCount = Slider.querySelectorAll(".splide__slide").length;

      // 1枚かどうかを判定
      const isStatic = slideCount <= 1;

      const commonSlider = new Splide(Slider, {
        autoplay: false,
        arrows: !isStatic,
        pagination: !isStatic,
        rewind: !isStatic,
        drag: !isStatic,
        pauseOnHover: false,
        pauseOnFocus: false,
        type: isStatic ? "slide" : "loop",
        speed: 500,
        gap: 30,
        perPage: 1,
      });

      commonSlider.mount();
    });
  }

  _initCommonSlider();

  // ==================================
  // 自動再生スライダー
  // ==================================
  function _initAutoplaySlider() {
    const Sliders = document.querySelectorAll(".js-autoplay-slider");
    if (Sliders.length === 0) return;

    Sliders.forEach((Slider) => {
      // スライド枚数をカウント
      const slideCount = Slider.querySelectorAll(".splide__slide").length;

      // 1枚かどうかを判定
      const isStatic = slideCount <= 1;

      const autoplaySlider = new Splide(Slider, {
        autoplay: !isStatic,
        arrows: !isStatic,
        pagination: !isStatic,
        rewind: !isStatic,
        drag: !isStatic,
        pauseOnHover: false,
        pauseOnFocus: false,
        type: isStatic ? "slide" : "loop",
        interval: 4000,
        speed: 500,
        gap: 30,
        perPage: 1,
      });

      autoplaySlider.mount();
    });
  }

  _initAutoplaySlider();

  // ==================================
  // イベント情報／ショップ・施設情報スライダー
  // ==================================
  function _initInfoPostSlider() {
    const Sliders = document.querySelectorAll(".js-info-post-slider");
    if (Sliders.length === 0) return;

    Sliders.forEach((Slider) => {
      const slideCount = Slider.querySelectorAll(".splide__slide").length;
      const isActive = (limit) => slideCount > limit;

      const infoPostSlider = new Splide(Slider, {
        perPage: 3,
        perMove: 1,
        pagination: false,
        gap: 42,
        speed: 500,
        arrows: isActive(3),
        drag: isActive(3),
        type: isActive(3) ? "loop" : "slide",

        // --- レスポンシブ設定 ---
        breakpoints: {
          // 1024px以下 (設定の調整のみ)
          1024: {
            gap: 24,
          },

          // 768px以下: 2枚表示
          768: {
            perPage: 2,
            gap: 24,
            arrows: isActive(2),
            drag: isActive(2),
            type: isActive(2) ? "loop" : "slide",
          },

          // 480px以下: 1枚表示
          480: {
            perPage: 1,
            gap: 24,
            arrows: isActive(1),
            drag: isActive(1),
            type: isActive(1) ? "loop" : "slide",
          },
        },
      });

      infoPostSlider.mount();
    });
  }

  _initInfoPostSlider();
}
